/**
 * Build metadata injected by vite.config.js `define`, derived from the last
 * git commit (see buildInfo() there). The typeof guards keep this importable
 * from plain node/vitest contexts where the defines aren't applied.
 *
 * Format: 2026.07.22.1659 — year.month.day.HHmm of the last commit.
 */
export const APP_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev';
export const APP_COMMIT = typeof __APP_COMMIT__ !== 'undefined' ? __APP_COMMIT__ : 'dev';
export const APP_COMMIT_ISO = typeof __APP_COMMIT_ISO__ !== 'undefined' ? __APP_COMMIT_ISO__ : '';

/** "CARO MANAGEMENT CONTROLLER v2026.07.22.1659" — footer label. */
export const APP_VERSION_LABEL = `CARO MANAGEMENT CONTROLLER v${APP_VERSION}`;

/** Localised build timestamp, e.g. "22/07/2026, 16:59". Empty when unknown. */
export function formatBuildDate(locale) {
  if (!APP_COMMIT_ISO) return '';
  const d = new Date(APP_COMMIT_ISO);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString(locale || [], {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
